import { render, staticRenderFns } from "./buyfaceorder.vue?vue&type=template&id=ffc4793e&scoped=true"
import script from "./buyfaceorder.vue?vue&type=script&lang=js"
export * from "./buyfaceorder.vue?vue&type=script&lang=js"
import style0 from "./buyfaceorder.vue?vue&type=style&index=0&id=ffc4793e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc4793e",
  null
  
)

export default component.exports